export default {
    ja: {
        info: {
            icon: 'Images/sns/icon_instagram.svg',
            link: 'https://www.instagram.com/event_natadera?igsh=dm02ZXVjeHFoeWNi',
            button: '最新情報をInstagramでチェック！',
        },
    },
    en: {
        info: {
            icon: 'Images/sns/icon_instagram.svg',
            link: 'https://www.instagram.com/event_natadera?igsh=dm02ZXVjeHFoeWNi',
            button: 'Official Instagram',
        },
    },

}